import { TableCell, TableCellProps } from "@mui/material";
import { ImpactUpdated } from "~/components/impact/Updated/impact-updated";
import { ScoreRating } from "~/operations";

interface ImpactCellProps {
  impact: number;
  rating: ScoreRating;
  isActive: boolean;
  hideTooltip?: boolean;
  cellProps?: TableCellProps;
  "data-testid"?: string;
}

export function ImpactCell({
  impact,
  rating,
  isActive,
  cellProps = {},
  ...props
}: ImpactCellProps) {
  return (
    <TableCell {...cellProps} data-testid={props["data-testid"]}>
      <ImpactUpdated
        impact={{ rating, value: impact }}
        isActive={isActive}
        isRiskScore
        hideTooltip={props.hideTooltip}
      />
    </TableCell>
  );
}
